/**
 * @internal true
 * @module briefing/DashboardBriefing
 * Container principal do Dashboard Briefing Diário.
 * Agrega: Header, Alertas, Agenda, Changelog, Mural TV e Equipe.
 * Carregamento progressivo independente por bloco.
 */
import { BriefingHeader } from './BriefingHeader';
import { BriefingAlerts } from './BriefingAlerts';
import { BriefingAgenda } from './BriefingAgenda';
import { BriefingMediaWall } from './BriefingMediaWall';
import { BriefingTeam } from './BriefingTeam';
import { BriefingChangelog } from './BriefingChangelog';
import { useBriefingData } from './useBriefingData';
import './briefing.css';
import '../../components/ui/datatable.css';

export function DashboardBriefing() {
  const data = useBriefingData();

  return (
    <div className="admin-page animate-fadeIn">
      <div className="briefing-root">
        {/* ═══ HERO HEADER ═══ */}
        <BriefingHeader
          nomeUsuario={data.nomeUsuario}
          nomeEscola={data.nomeEscola}
          saudacao={data.saudacao}
          dataFormatada={data.dataFormatada}
          perfil={data.perfil}
          cargo={data.cargo}
          eventosHoje={data.eventosHoje.length}
          incidentesAtivos={data.incidentesAtivos.length}
          presentesHoje={data.frequencia.presentesHoje}
          totalAlunos={data.frequencia.totalAlunos}
          totalTurmas={data.frequencia.totalTurmas}
          pctPresenca={data.frequencia.pctPresenca}
          loading={data.loadingFrequencia && data.loadingAgenda}
        />

        {/* ═══ GRID PRINCIPAL ═══ */}
        <div className="briefing-grid">
          {/* ── Coluna principal (esquerda) ── */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {/* Alertas / Incidentes (P0) */}
            <BriefingAlerts
              incidentes={data.incidentesAtivos}
              loading={data.loadingIncidentes}
              onResolve={data.resolverIncidente}
            />

            {/* Agenda do Dia (P1) */}
            <BriefingAgenda
              eventos={data.eventosHoje}
              loading={data.loadingAgenda}
            />

            {/* Novidades do Sistema (P3) */}
            <BriefingChangelog />
          </div>

          {/* ── Coluna lateral (direita) ── */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {/* Mural TV (P1) */}
            <BriefingMediaWall hasMediaData={false} />

            {/* Equipe Online (P2) */}
            <BriefingTeam />
          </div>
        </div>
      </div>
    </div>
  );
}
